<template>
    <Form ref="elementRef" :validation-schema="elementSchema">
        <div class="row">
            <div class="col-10">
                <div class="row">

                <div class="col">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18">
                    
                    <Field name="annee" v-model="props.element.annee"  v-slot="{ field }" @input="modifierDonnees">
                    <Multiselect 
                        :options="props.options" 
                        :searchable="true"
                        :disabled="props.element.des"
                        @change="verifier"
                        @deselect="aLaDeslect"
                        @remove="aLaDeslect"
                        v-model="field.value"
                        v-bind="field"
                        placeholder="Sélectionner"
                    />
                    </Field>
                    <ErrorMessage name="annee" class="text-danger"/>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18">
                    <Field name="loyer" v-model="props.element.loyer" type="text"  @input="modifierDonnees"
                        class="form-control shadow-none fs-md-15 text-black"/>
                        <ErrorMessage name="loyer" class="text-danger"/>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18">
                    <Field name="mois" type="text"  v-model="props.element.mois" @input="modifierDonnees"
                        class="form-control shadow-none fs-md-15 text-black"/>
                        <ErrorMessage name="mois" class="text-danger"/>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18">
                        <Field name="montant" type="text" v-model="props.element.montant" :readonly="true"  @input="modifierDonnees"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="montant" class="text-danger"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1">
                <div class="form-group mb-10 mb-sm-15 mb-md-18 --center">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input shadow-none" type="checkbox" v-model="isChecked" @change="handleCheckboxChange">
                    </div>
                </div>
            </div>
            <div class="col-1">
                <div class="form-group mb-10 mb-sm-15 mb-md-18">
                    <div>
                        <button type="button" @click="supprimerElement(props.element.id)" class="default-btn btn-danger --center text-center position-relative transition border-0 fw-medium pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"><i class="flaticon-delete text-center position-relative text-white ms-5 fs-20"></i></button>
                    </div>
                </div>
            </div>
        </div>
       
    </Form>
</template>
<script lang="ts">
import { defineComponent, ref,watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Multiselect from '@vueform/multiselect'
import {Option} from "@/models/Option";
import Swal from 'sweetalert2';
import { hideModal, showModal, success, error } from '@/utils/utils';
import * as Yup from 'yup';

export default defineComponent({
  name: "ElementVue",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  setup: (props, { emit }) => {
    const elementSchema = Yup.object().shape({
        annee: Yup.number().typeError('Veuillez entrer une année').required(`L'année est obligatoire`),
        mois: Yup.number().default(0).typeError('Veuillez entrer un nombre').max(12,"Le nombre de mois ne peut dépasser 12").required(`Le nombre est obligatoire`),
        loyer: Yup.number().default(0).typeError('Veuillez entrer le taux').required(`Le taux est obligatoire`),
        montant: Yup.number().default(0).typeError('Veuillez entrer une montant').required(`Le montant est obligatoire`),
    });
    const selectionCheck = ref(false);
    const elementt = ref(props.element);
    const modifierDonnees = () => {
      emit('modification', props.element);
    };
    const verifier = (value) => {
      emit('auchangement', value);
    };
    const aLaDeslect = (value) => {
      emit('sortie', value);
    };
    const supprimerElement = (id) =>{
        emit('suppression', id);
    }
    onMounted(async() => {
        //
      });
    const isChecked = ref(false);

    function handleCheckboxChange(event) {
        if(props.element.annee == 0){
            Swal.fire({
            icon: 'warning',
            title: 'Attention',
            text: `L'année n'est pas renseigner, veuillez selectionner une année`,
          }) 
          isChecked.value = false;
          return false;
        }
        if(isChecked.value === true){
            emit('sortie', props.element.annee);
        }else{
            emit('auchangement',props.element.annee)
        }
        
    }


   
    watch(() => elementt.value.loyer, (nouveauLoyer, ancienLoyer) => {
        if(nouveauLoyer !== ancienLoyer){
            elementt.value.loyer = isNaN(nouveauLoyer) ? 0 : parseInt(nouveauLoyer);
            const mont = (nouveauLoyer? parseFloat(nouveauLoyer) : 0) * (elementt.value.mois?  parseInt(elementt.value.mois) : 0);
            elementt.value.montant =  mont;
           emit('somme');
        }
    });
    watch(() => elementt.value.mois, (nouveauMois, ancienNombre) => {
        if(nouveauMois !== ancienNombre){
            elementt.value.mois = isNaN(nouveauMois) ? 0 : parseInt(nouveauMois);
            const monte = (!isNaN(nouveauMois)? parseInt(nouveauMois) : 0) * (elementt.value.loyer ? parseFloat(elementt.value.loyer) : 0);
            elementt.value.montant = monte;
            emit('somme');
            emit("verifiSommeMois");
        }
    });
    onMounted(() => {
      //
    });

    return { elementSchema,elementt,supprimerElement,selectionCheck,handleCheckboxChange,isChecked, modifierDonnees,props,verifier,aLaDeslect };
  }
});

</script>

<style src="@vueform/multiselect/themes/default.css"></style>